import byLocationIdReducerFactory from 'locations/reducers/byLocationIdReducerFactory';
import { LOCATION_THROTTLED_TIMES } from 'locations/constants/entities';
import { getLocationThrottledTimesActionTypes } from 'locations/actions/locationThrottledTimes';

export default byLocationIdReducerFactory(
  LOCATION_THROTTLED_TIMES,
  getLocationThrottledTimesActionTypes().map(actionType => actionType.type)
);
